import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const logsApi = createApi({
  reducerPath: "logsApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api" }),
  endpoints: (b) => ({
    writeLog: b.mutation<
      void,
      { level: string; event: string; detail?: any; ts?: string }
    >({
      query: (body) => ({ url: `logs`, method: "POST", body }),
    }),
  }),
});

export const { useWriteLogMutation } = logsApi;

